










































































































































































































import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { IFilm } from "@/@types/cinema/films";
import { IFilmCategory } from "@/@types/cinema/film-category";
import { multimedia } from "@/config/host.config";
import langConfig from "@/config/languags.config.json";

import CinemaListHeader from "./additionally/cinema-list-header.vue";
import CinemaCategoryTabs from "./additionally/cinema-category-tabs.vue";
import MovieTableCard from "./additionally/movie-table-card.vue";
import FullMovieCard from "./full-movie-card.vue";
import ChangeMovieForm from "./change-movie-form.vue";
import StandartCategoryName from "@/components/app/card/standart-category-name.vue";
import StandartTable from "@/components/tables/standart-table.vue";
import StandartModal from "@/components/app/standart-modal.vue";

interface ISortColumn {
  name: number;
  status: number;
  year: number;
  category: number;
}

@Component({
  components: {
    CinemaListHeader,
    CinemaCategoryTabs,
    MovieTableCard,
    FullMovieCard,
    ChangeMovieForm,
    StandartCategoryName,
    StandartTable,
    StandartModal,
  },
})
export default class CinemaList extends Vue {
  @Prop({ type: Array, default: () => [] }) categoryList!: Array<IFilmCategory>;
  @Prop({ type: Array, default: () => [] }) cinemaList!: Array<IFilm>;
  @Prop({ type: String, default: "" }) activeCategory!: string;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;

  @Inject() readonly bgFolder!: string;
  @Inject() readonly posterFolder!: string;
  @Inject() readonly logoFolder!: string;

  lightList: Array<IFilm> = [];
  displayLimit = 50;
  movie_id = "";
  watch_movie_id = "";
  watch_src = "";
  watch_error = false;
  search = "";
  sortKey = "";
  sortOrder: ISortColumn = { name: 1, status: -1, year: -1, category: -1 };
  ddOpen = false;

  get movies(): Array<IFilm> {
    const search = this.search && this.search.toLowerCase();
    const order = this.sortOrder[this.sortKey as keyof ISortColumn] || 1;

    let list: IFilm[];

    if (this.activeCategory) {
      list = this.cinemaList.filter((item) => {
        if (item.categorys && item.categorys.length)
          for (const category of item.categorys) {
            if (category == this.activeCategory) return true;
          }
        return false;
      });
    } else {
      list = search ? this.cinemaList : this.lightList;
    }

    if (search) {
      list = list.filter((item) => {
        if (item.name) {
          return (
            this.$getLocale(item.name)
              .toLowerCase()
              .indexOf(search.toLowerCase()) > -1
          );
        }
      });
    }

    if (this.sortKey) {
      if (this.sortKey == "name") {
        list = list.slice().sort((a: IFilm, b: IFilm) => {
          const one = this.$getLocale(a.name);
          const two = this.$getLocale(b.name);
          return (one === two ? 0 : one > two ? 1 : -1) * order;
        });
      }

      if (this.sortKey == "year") {
        list = list.slice().sort((a: IFilm, b: IFilm) => {
          const one = a.year;
          const two = b.year;
          return (
            (one === two ? 0 : !one ? 1 : !two ? -1 : one > two ? 1 : -1) *
            order
          );
        });
      }
      if (this.sortKey == "category") {
        list = list.slice().sort((a: IFilm, b: IFilm) => {
          const one = a.categorys[0];
          const two = b.categorys[0];
          return (one === two ? 0 : one > two ? 1 : -1) * order;
        });
      }
      if (this.sortKey == "status") {
        list = list.slice().sort((a: IFilm, b: IFilm) => {
          const one = a.show;
          const two = b.show;
          return (
            (one === two ? 0 : !one ? 1 : !two ? -1 : one > two ? 1 : -1) *
            order
          );
        });
      }
    }

    return this.activeCategory || search
      ? list.slice(0, this.displayLimit)
      : list;
  }

  get movie(): IFilm | null {
    const movie = this.cinemaList.find((m) => this.movie_id == m._id);
    return movie ? movie : null;
  }

  get watchFilm(): IFilm | null {
    const movie = this.cinemaList.find((m) => this.watch_movie_id == m._id);
    return movie ? movie : null;
  }

  get watchTitle(): string {
    const film = this.watchFilm;
    return film ? this.$getLocale(film.name) : "";
  }

  get watchSrc(): string {
    const film = this.watchFilm;
    if (!film || !film._id) return "";
    const token = this.$store.getters.getAccess;
    return `${multimedia.movie}${film._id}?Authorization=${`Bearer ${token}`}`;
  }

  get watchPoster(): string {
    const film = this.watchFilm;
    if (!film || !film.src) return "";
    if (film.src.bg) {
      return this.$getWebImage(film.src.bg, `${this.bgFolder}/fullhd`);
    }
    const poster = this.localeImage(film.src.poster);
    if (poster) {
      return this.$getWebImage(
        poster.img,
        `${this.posterFolder}/${poster.lang}/origin`
      );
    }
    const vertical = this.localeImage(film.src.vertical_poster);
    return vertical
      ? this.$getWebImage(
          vertical.img,
          `cinema/vertical_poster/${vertical.lang}/origin`
        )
      : "";
  }

  get heroStyle(): { backgroundImage: string } {
    return this.watchPoster
      ? { backgroundImage: `url("${this.watchPoster}")` }
      : { backgroundImage: "none" };
  }

  get watchRatingKP(): string {
    const film = this.watchFilm;
    return film && film.ratings && film.ratings.ratingKinopoisk
      ? String(film.ratings.ratingKinopoisk)
      : "";
  }

  get watchRatingIMDB(): string {
    const film = this.watchFilm;
    return film && film.ratings && film.ratings.ratingImdb
      ? String(film.ratings.ratingImdb)
      : "";
  }

  get watchDuration(): string {
    const film = this.watchFilm;
    if (!film || !film.filmLength) return "";
    return `${film.filmLength} ${this.$t("configuration.weather.min")}`;
  }

  get watchAge(): string {
    const film = this.watchFilm;
    if (!film || !film.ratingAgeLimits) return "";
    let clean = film.ratingAgeLimits.replace(/^age/i, "");
    if (/^\d+$/.test(clean)) clean += "+";
    return clean;
  }

  get watchDescription(): string {
    const film = this.watchFilm;
    if (!film) return "";
    if (film.shortDescription) return this.$getLocale(film.shortDescription);
    return film.description ? this.$getLocale(film.description) : "";
  }

  localeImage(obj?: {
    [x: string]: string;
  }): { img: string; lang: string } | null {
    if (!obj) return null;
    const keys = Object.keys(obj);
    if (!keys.length) return null;
    const prefs = [
      this.$i18n.locale,
      langConfig.preferred_language,
      "en",
      String(this.$i18n.fallbackLocale),
    ];
    for (const pref of prefs) {
      if (keys.includes(pref)) return { img: obj[pref], lang: pref };
    }
    return { img: obj[keys[0]], lang: keys[0] };
  }

  openMovie(id: string): void {
    this.movie_id = id;
    this.$nextTick(() => this.$bvModal.show("movie"));
  }

  openWatchMovie(id: string): void {
    this.watch_error = false;
    this.watch_movie_id = id;
    this.watch_src = this.watchSrc;
    this.$nextTick(() => this.$bvModal.show("movie-watch"));
  }

  onWatchHidden(): void {
    this.watch_movie_id = "";
    this.watch_src = "";
    this.watch_error = false;
  }

  editMovie(id: string): void {
    this.movie_id = id;
    this.$nextTick(() => this.$bvModal.show("movie-form"));
  }

  async deleteMovie(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("Cinema.buttons.delete-movie")),
        }
      );
      if (result === true) {
        this.$emit("deletedMovie", id);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  sortBy(key: string): void {
    this.sortKey = key;
    this.sortOrder[key as keyof ISortColumn] =
      this.sortOrder[key as keyof ISortColumn] * -1;
  }

  async mustDeleteMovie(): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("Cinema.buttons.delete-movie")),
        }
      );

      if (result === true) {
        this.$emit("deletedMovie", this.movie_id);
        this.movie_id = "";
        this.$bvModal.hide("movie");
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  checkPosition(): void {
    const height = document.body.offsetHeight;
    const screenHeight = window.innerHeight;

    if (height <= screenHeight) return;

    const scrolled = window.scrollY;
    const threshold = height - screenHeight / 4;
    const position = scrolled + screenHeight;

    if (position >= threshold) {
      if (this.activeCategory || this.search) {
        this.displayLimit += 20;
      } else {
        this.lightList = this.cinemaList.slice(0, this.lightList.length + 20);
      }
    }
  }

  @Watch("search")
  onSearchChange(): void {
    this.displayLimit = 50;
  }

  @Watch("activeCategory")
  onActiveCategoryChange(): void {
    this.displayLimit = 50;
  }

  @Watch("cinemaList", { deep: true })
  updateLightList(): void {
    const length = this.cinemaList.length;
    const count = this.lightList.length ? this.lightList.length : 50;
    this.lightList = this.cinemaList.slice(0, length > count ? count : length);
  }

  @Watch("movie")
  closeMovieCard(): void {
    if (!this.movie && this.movie_id) {
      this.movie_id = "";
      this.$bvModal.hide("movie");
    }
  }

  updateMovie(id: string, data: Partial<IFilm>): void {
    this.$emit("updateMovie", id, data);
  }

  mounted(): void {
    this.updateLightList();
    this.displayLimit = 50;
    window.addEventListener("scroll", this.checkPosition);
  }

  beforeDestroy(): void {
    window.removeEventListener("scroll", this.checkPosition);
  }
}
